<!--详情页面-基本信息等card-->
<template>
  <el-row
    v-loading="loading"
    :gutter="16"
    :class="{'single-row': styleType === 'singleRow'}"
    :style="detailStyle"
    class="detail-card">
    <!-- 以下结构写两份。原因有两个
    第一:有这个:xs="24" :sm="12" :md="14" :lg="8" :xl="8"样式覆盖太多。
    第二:之后要是所有的都改成一行显示一个块的样式，上面的那个结构直接删除了就可以。-->
    <template v-if="!styleType">
      <el-col v-for="(item, index) in detailData" :key="index" :xs="24" :sm="12" :md="14" :lg="8" :xl="8">
        <div class="card">
          <div v-if="item.title" class="detail-card--title">
            <span>{{ item.title || '-' }}</span>
          </div>
          <div class="detail-card--content">
            <template v-if="!item.content || item.content && !item.content.length">
              <p class="content-item">{{ $t('monitor.no_data') }}</p>
            </template>
            <template v-for="(item0, index0) in item.content" :key="index0" v-else>
              <div :class="[item0.prop, {'mt0': index0 === 0}]" :style="item0.style" class="content-item">
                <div v-if="item0.key || item0.label" :title="item0.keyTip ? item0.key || item0.label : ''" class="content-item--label line-2">{{ item0.key || item0.label }}:</div>
                <template v-if="item0.value && item0.value.length > 29">
                  <el-tooltip
                    :show-after="700"
                    :content="item0.value ? item0.value.toString() : '-'"
                    placement="bottom-start"
                    effect="light">
                    <template #content>
                      <div slot="content" class="slot-content">
                        <div v-html="item0.value ? (item0.isPassword && item0.isShowPassword ? Array.from(item0.value, () => '*').join('') : item0.value) : '-'"></div>
                      </div>
                    </template>
                    <div
                      :class="[{'is-click': item0.router, 'line-5' : !!!item0.showAll}, item0.line]"
                      class="content-item--value">
                      <svg-icon v-if="item0.icon" :icon-class="item0.icon"/>
                      <template v-if="item0.status">
                        <!--default-->
                        <i
                          v-if="$status_all && $status_all.default.includes(item0.status)"
                          class="default-circle"></i>
                        <!--loading-->
                        <i
                          v-if="$status_all && $status_all.doing.includes(item0.status)"
                          class="el-icon-loading"></i>
                        <!--failed-->
                        <i
                          v-if="$status_all && $status_all.failed.includes(item0.status)"
                          class="error-circle"></i>
                        <!--warning-->
                        <i
                          v-if="$status_all && $status_all.warning.includes(item0.status)"
                          class="warning-circle"></i>
                        <!--done-->
                        <i
                          v-if="$status_all && $status_all.done.includes(item0.status)"
                          class="success-circle"></i>
                      </template>
                      <!--密码显示***-->
                      <span v-html="item0.value ? (item0.isPassword && item0.isShowPassword ? Array.from(item0.value, () => '*').join('') : item0.value) : '-'"></span>
                      <!--密码小眼睛-->
                      <svg-icon
                        v-if="item0.isPassword && item0.value"
                        :icon-class="item0.isShowPassword ? 'eye' : 'eye-close'"
                        class="show-password"
                        @click="item0.isShowPassword = !item0.isShowPassword"/>
                    </div>
                  </el-tooltip>
                </template>
                <template v-else>
                  <div
                    :class="[{'is-click': item0.router, 'line-5' : !!!item0.showAll}, item0.line]"
                    class="content-item--value">
                    <svg-icon v-if="item0.icon" :icon-class="item0.icon"/>
                    <template v-if="item0.status">
                      <!--default-->
                      <i
                        v-if="$status_all && $status_all.default.includes(item0.status)"
                        class="default-circle"></i>
                      <!--loading-->
                      <i
                        v-if="$status_all && $status_all.doing.includes(item0.status)"
                        class="el-icon-loading"></i>
                      <!--failed-->
                      <i
                        v-if="$status_all && $status_all.failed.includes(item0.status)"
                        class="error-circle"></i>
                      <!--warning-->
                      <i
                        v-if="$status_all && $status_all.warning.includes(item0.status)"
                        class="warning-circle"></i>
                      <!--done-->
                      <i
                        v-if="$status_all && $status_all.done.includes(item0.status)"
                        class="success-circle"></i>
                    </template>
                    <!--密码显示***-->
                    <span v-html="item0.value ? (item0.isPassword && item0.isShowPassword ? Array.from(item0.value, () => '*').join('') : item0.value) : '-'"></span>
                    <!--密码小眼睛-->
                    <svg-icon
                      v-if="item0.isPassword && item0.value"
                      :icon-class="item0.isShowPassword ? 'eye' : 'eye-close'"
                      class="show-password"
                      @click="item0.isShowPassword = !item0.isShowPassword"/>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </el-col>
    </template>
    <!-- 一行显示 -->
    <template v-if="styleType === 'singleRow'">
      <el-col v-for="(item, index) in detailData" :key="index">
        <div :class="{'noBorderBottom': index === detailData.length - 1}" class="card">
          <div v-if="item.title" class="detail-card--title">
            <span>{{ item.title || '-' }}</span>
          </div>
          <div class="detail-card--content">
            <template v-if="!item.content || item.content && !item.content.length">
              <p class="content-item">{{ $t('monitor.no_data') }}</p>
            </template>
            <template v-for="(item0, index0) in item.content" :key="index0" v-else>
              <div
                v-if="item0.type === 'slot'"
                :class="[item0.prop, 'content-item', 'content-item--slot']"
                :style="item0.style">
                <div
                  v-if="item0.key || item0.label"
                  :title="item0.keyTip ? item0.key || item0.label : ''"
                  class="content-item--label line-2">{{ item0.key || item0.label }}:</div>
                <div
                  class="content-item--value content-item--slot-inner"
                  :style="item0.valueStyle">
                  <slot :name="item0.prop" :slotObj="item0" />
                </div>
              </div>
              <div v-else :class="[item0.prop]" :style="item0.style" class="content-item">
                <div v-if="item0.key || item0.label" :title="item0.keyTip ? item0.key || item0.label : ''" class="content-item--label line-2">{{ item0.key || item0.label }}:</div>
                <template v-if="!item0.valueHide && !item0.valueTooltipHide && item0.value && item0.value.length > 29">
                  <el-tooltip
                    :show-after="700"
                    :content="item0.value ? item0.value.toString() : '-'"
                    placement="bottom-start"
                    effect="light">
                    <template #content>
                      <div slot="content" class="slot-content">
                        <div v-html="item0.value ? (item0.isPassword && item0.isShowPassword ? Array.from(item0.value, () => '*').join('') : item0.value) : '-'"></div>
                      </div>
                    </template>
                    <div
                      :class="[{'is-click': item0.router, 'line-5' : !!!item0.showAll}, item0.line]"
                      :style="item0.valueStyle"
                      class="content-item--value">
                      <svg-icon v-if="item0.icon" :icon-class="item0.icon"/>
                      <template v-if="item0.status">
                        <!--default-->
                        <i
                          v-if="$status_all && $status_all.default.includes(item0.status)"
                          class="default-circle"></i>
                        <!--loading-->
                        <i
                          v-if="$status_all && $status_all.doing.includes(item0.status)"
                          class="el-icon-loading"></i>
                        <!--failed-->
                        <i
                          v-if="$status_all && $status_all.failed.includes(item0.status)"
                          class="error-circle"></i>
                        <!--warning-->
                        <i
                          v-if="$status_all && $status_all.warning.includes(item0.status)"
                          class="warning-circle"></i>
                        <!--done-->
                        <i
                          v-if="$status_all && $status_all.done.includes(item0.status)"
                          class="success-circle"></i>
                      </template>
                      <!--密码显示***-->
                      <span v-html="item0.value ? (item0.isPassword && item0.isShowPassword ? Array.from(item0.value, () => '*').join('') : item0.value) : '-'"></span>
                      <!--密码小眼睛-->
                      <svg-icon
                        v-if="item0.isPassword && item0.value"
                        :icon-class="item0.isShowPassword ? 'eye' : 'eye-close'"
                        class="show-password"
                        @click="item0.isShowPassword = !item0.isShowPassword"/>
                    </div>
                  </el-tooltip>
                </template>
                <template v-else-if="!item0.valueHide">
                  <div
                    :class="[{'is-click': item0.router, 'line-5' : !!!item0.showAll}, item0.line]"
                    :style="item0.valueStyle"
                    class="content-item--value">
                    <svg-icon v-if="item0.icon" :icon-class="item0.icon"/>
                    <template v-if="item0.status">
                      <!--default-->
                      <i
                        v-if="$status_all && $status_all.default.includes(item0.status)"
                        class="default-circle"></i>
                      <!--loading-->
                      <i
                        v-if="$status_all && $status_all.doing.includes(item0.status)"
                        class="el-icon-loading"></i>
                      <!--failed-->
                      <i
                        v-if="$status_all && $status_all.failed.includes(item0.status)"
                        class="error-circle"></i>
                      <!--warning-->
                      <i
                        v-if="$status_all && $status_all.warning.includes(item0.status)"
                        class="warning-circle"></i>
                      <!--done-->
                      <i
                        v-if="$status_all && $status_all.done.includes(item0.status)"
                        class="success-circle"></i>
                    </template>
                    <!--密码显示***-->
                    <span v-html="item0.value ? (item0.isPassword && item0.isShowPassword ? Array.from(item0.value, () => '*').join('') : item0.value) : '-'"></span>
                    <!--密码小眼睛-->
                    <svg-icon
                      v-if="item0.isPassword && item0.value"
                      :icon-class="item0.isShowPassword ? 'eye' : 'eye-close'"
                      class="show-password"
                      @click="item0.isShowPassword = !item0.isShowPassword"/>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </el-col>
    </template>
  </el-row>
</template>

<script>
export default {
  name: 'Detail',
  props: {
    styleType: {
      type: String,
      default: ''
    },
    detailStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import '@/styles/variables.scss';
.detail {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.tab-group {
  width: 100%;
}
.detail-card {
  display: flex;
  flex: 1;
  max-height: calc(100% - 55px);
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
  align-items: flex-start;
  align-content: flex-start;

  .card {
    padding: 0 10px 20px 20px;
    box-sizing: border-box;
    height: 362px;
    background: $white;
    margin-bottom: 16px;
    box-shadow: 0px 2px 10px 0px rgba($color: $black, $alpha: .08);
    border-radius: 4px;
  }

  &--title {
    height: 40px;
    display: flex;
    align-items: center;
    color: $grey-9;
    font-size: 16px;
    font-weight: bold;
  }

  &--content {
    padding-right: 10px;
    width: 100%;
    height: calc(100% - 40px);
    overflow-y: scroll;
    overflow-x: hidden;

    .content-item {
      margin-top: 8px;
      width: 100%;
      font-size: 14px;

      .slot-content {
        max-width: 50%;
      }

      &--label {
        width: 170px;
        min-width: 170px;
        text-align: left;
        color: $grey-7;
      }

      &--value {
        margin-top: 4px;
        color: $grey-9;
        text-align: left;
        line-height: 22px;
        word-wrap: break-word;
        word-break: break-all;
        display: flex;
        align-items: center;
        &>svg {
          margin-right: 4px;
        }

        &.is-click {
          cursor: pointer;
          color: var(--el-color-primary);

          &:hover {
            text-decoration: underline;
          }
        }
      }
      .svg-icon.show-password {
        color: $grey-6;
        margin-left: 8px;
        cursor: pointer;
        min-width: 14px;
      }
    }
  }
  &.single-row {
    overflow: auto;
    .card {
      box-shadow: none;
      height: auto;
      border-bottom: 1px solid $grey-4;
      border-radius: 0;
      padding: 0 0 16px;
      &.noBorderBottom {
        border-bottom: none;
      }
      .detail-card--title {
        height: 24px;
      }
    }
    .detail-card--content {
      display: flex;
      flex-wrap: wrap;
      .content-item {
        width: 50%;
        float: left;
      }
      .content-item--slot {
        width: 100%;
        flex-basis: 100%;
      }
      .content-item--slot-inner {
        display: block;
        width: 100%;
      }
      .content-item--label {
        width: 170px;
        min-width: 170px;
      }
      &:last-child {
        padding-right: 0 !important;
      }
    }
    .el-col-24 {
      padding-right: 0 !important;
    }
  }
  .failed, .disabled, .disable {
    vertical-align: middle;
    display: inline-block;
    background-color: var(--el-color-error);
    height: 6px;
    width: 6px;
    border-radius: 50%;
  }
  .success, .enabled, .enable {
    display: inline-block;
    background-color: var(--el-color-success);
    height: 6px;
    width: 6px;
    border-radius: 50%;
  }
}
</style>
